import React, { Component } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth,scrollToTop } from "../Helpers/SettingHelper";
import { apiUrl, mediaUrl} from'../Config/Config';
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import MyEditor from './MyEditor';

const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };

class WalletPlanEdit extends Component {

	constructor(props)
	{
		CheckAuth();
		super(props);	
	    const walletplanId = (typeof this.props.params.ID === 'undefined') ? '' : this.props.params.ID;
		this.state = {
            walletplanId: walletplanId,
			m_title:'',
			description:'',
			planInfo:'',
			amount:0,
			discount:0,
			driverCount:0,
			companyCount:0,
			period:'',
			Loading:false,
			selectedOption:{ value: 'active', label: 'Active'},
			selectedPeriodOption: { value: 'month', label: 'Month' },
			selectedPlanOption: "",
			selectedvalue:'active',
			selectedPeriodvalue:'',
			selectedPlanvalue:'',
			planLists:'',
			initialData :'',
			old_wallletplan_img:'',
		};
		
			
		console.log(this.state, 'ressss0');
		// console.log(res.data.membershiplist, 'resssss');

		
		
		this.handleInputChange = this.handleInputChange.bind(this);
	    this.handleChange = this.handleChange.bind(this);
	    this.onChangeHandler = this.onChangeHandler.bind(this);
		this.onEditorChange = this.onEditorChange.bind( this );
    }

	// onEditorChange( evt ) {
	// 	this.setState( {
    //         description: evt.editor.getData()
    //     } );
    // }
// 	onEditorChange( evt ) {
		
// 		console.log(evt, 'CKE')

// 	   var callfunc = this;
// 	   setTimeout(function () {
// 		this.setState( {
//             description: evt
//         } );
// 		}.bind(this),1000);
	
//    }
   	onEditorChange(r, evt) {
		if(r == 'description'){
			const converted = this.emojiToEntity(evt);
			this.setState({ description: converted });
		}
		else if (r == "planBenefits") {
			console.log(r);
			const converted = this.emojiToEntity(evt);
			this.setState({ planBenefits: converted });
		}
	}

	emojiToEntity(str) {
		return str.replace(/\p{Emoji_Presentation}|\p{Emoji}\uFE0F/gu, emoji => {
			return `&#${emoji.codePointAt(0)};`;
		});
	}

   	onChangeHandler=event=>{
		let reader = new FileReader();
		const file = event.target.files[0];
		const extension = file.name.split('.').pop();
		reader.onloadend = () => {
			this.setState({
				icon_name: file.name,
				icon_preview: reader.result,
				icon: file,
				icon_fileExtension:extension,			
			});
		};
		reader.readAsDataURL(file);
	} 
    handleChange = (r,selOption) => {
       
		if(r == 'status'){
			this.setState({selectedOption:selOption})
			this.setState({  selectedvalue : selOption.value});
		}else if(r == 'period'){
			this.setState({selectedPeriodOption:selOption})
			this.setState({  selectedPeriodvalue : selOption.value});
		}else if(r == 'plan'){			
			this.setState({selectedPlanOption:selOption})
			this.setState({  selectedPlanvalue : selOption.value});
			this.setState({  selectedUserType : selOption.type});
		}
		console.log(selOption.value, 'sdfg')
 	};

   	handleInputChange(event) {
		const {name, value} = event.target;   
		 const numberFields = ["walletAmt", "earnPoints", "extraBonusPoints"];

		// If field should be numeric → validate
		if (numberFields.includes(name)) {
			// Allow only numbers (you can tweak regex if needed)
			if (!/^\d*$/.test(value)) {
			return; 
			}
		}

		this.setState({
			[name]: value
		});	
    }

	componentDidMount() {
		
		var qs = require('qs');
		var walletplanId = this.state.walletplanId;

		axios.get(apiUrl+"walletplan/listdetail?id="+walletplanId).then(res => {
			console.log(res, 'res000');
			this.setState({
				title:res.data.listdetail.title,
				description:res.data.listdetail.description,
				planBenefits:res.data.listdetail.planBenefits,
				walletAmt:res.data.listdetail.walletAmt,
				earnPoints:res.data.listdetail.earnPoints,
				extraBonusPoints:res.data.listdetail.extraBonusPoints==0 ? "":res.data.listdetail.extraBonusPoints,
				});
			if(res.data.listdetail.status === 'A'){
				this.setState({selectedOption:{value: 'active', label: 'Active'}});
			}else{
				this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
			}

			
			if(res.data.listdetail.image !== null){
				this.setState({old_wallletplan_img:res.data.listdetail.image});
			}

		document.title = PageTitle('Wallet Plan Edit');
        }); 
	}
	

	Capitalize = (str) => {
		return str.charAt(0).toUpperCase() + str.slice(1);
	}

	
    handleFormSubmit = () => {
		if(this.validateForm()){ 
			this.setState({Loading:true});
			const config = {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
				};
			const formPayload = this.state;
			var qs = require('qs');
			var status = '';

			if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
				status =formPayload.selectedOption.value;
			}else{
				status = formPayload.selectedvalue;
			}

			

			

			var postObject = {
				walletplanId:this.state.walletplanId,
				admin_id : localStorage.getItem("admin_id"),
				title: formPayload.title,
				description: formPayload.description,
				planBenefits: formPayload.planBenefits,
				walletAmt: formPayload.walletAmt,
				earnPoints: formPayload.earnPoints,
				extraBonusPoints: formPayload.extraBonusPoints,
				status: status,
				old_wallletplan_img:formPayload.old_wallletplan_img,
			
			};
			let formData = new FormData();
			for(let k in postObject) {
			formData.append(k, postObject[k]);
			}		       
			var icondata = formPayload.icon;
			formData.append('file',icondata)
			//axios.post(apiUrl+"membership/edit",qs.stringify(postObject) ).then(res => {
			axios.post(apiUrl+"walletplan/edit",formData).then(res => {
				if(res.data.status === "success"){	
					this.setState({Loading:false});
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');							
					setTimeout(
						function() {
							$('.success_message').html(this.props.navigate('/walletplans'));
						}
					.bind(this),
					3000
					);
				}else{
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					
					setTimeout(
					function() {
						$('.success_message').html('');
					}
					.bind(this),
					3000
					);
					this.setState({Loading:false});
				}
			});
		}
	}

	validateForm() {
		//const {admin_company_name,admin_fname} = this.state;
		const { title,
      description,
      planBenefits,
      walletAmt,
      earnPoints,
      extraBonusPoints,} = this.state;
		let errors = {};
      	let formIsValid = true;
		  const nameRegex = /^[A-Za-z\s.]+$/;

		    if (!title) {
				errors++;
				$(".errortitle").html(
				  '<span class="errorspan">Please fill the field</span>',
				);
			  } else if (title) {
				if (!nameRegex.test(title)) {
				  errors++;
				  $(".errortitle").html(
					'<span class="errorspan">Please enter the valid wallet plan</span>',
				  );
				} else {
				  $(".errortitle").html("");
				}
			  }
			  // if (!description) {
			  // 	formIsValid = false;
			  // 	$('.errordescription').html('<span class="errorspan">Please fill the field</span>');
			  // }else if(description){
			  // 	$('.errordescription').html('');
			  // }
		  
				   if (!walletAmt) {
				formIsValid = false;
				$(".errorwalletAmt").html(
				  '<span class="errorspan">Please fill the field</span>',
				);
			  } else if (walletAmt) {
				if (/^[0-9]*\.?[0-9]*$/.test(walletAmt)) {
				  $(".errorwalletAmt").html("");
				} else {
				  formIsValid = false;
				  $(".errorwalletAmt").html(
					'<span class="errorspan">Please enter the valid wallet amount</span>',
				  );
				}
			  }
		  
				if (!earnPoints) {
				formIsValid = false;
				$(".errorearnPoints").html(
				  '<span class="errorspan">Please fill the field</span>',
				);
			  } else if (earnPoints) {
				if (/^[0-9]*\.?[0-9]*$/.test(earnPoints)) {
				  $(".errorearnPoints").html("");
				} else {
				  formIsValid = false;
				  $(".errorearnPoints").html(
					'<span class="errorspan">Please enter the valid earn points</span>',
				  );
				}
			  }
			  
			   // if (!extraBonusPoints) {
			  //   formIsValid = false;
			  //   $(".errorwalletAmt").html(
			  //     '<span class="errorspan">Please fill the field</span>',
			  //   );
			  // } else 
			  if (extraBonusPoints) {
				if (/^[0-9]*\.?[0-9]*$/.test(extraBonusPoints)) {
				  $(".errorextraBonusPoints").html("");
				} else {
				  formIsValid = false;
				  $(".errorextraBonusPoints").html(
					'<span class="errorspan">Please enter the valid extra bonus points</span>',
				  );
				}
			  }
			 
		  
			  this.setState({
				errors: errors,
			  });
			  return formIsValid;
    }

  render() {
	
  	const {selectedOption,description} = this.state;
		if(description!==undefined){
			var desc = description;	
		}
		let loaderimg = '';
		var	preview = (this.state.icon_preview) ? 
			<img className="img_class" src={this.state.icon_preview} alt="" /> :
			<img className="img_class" src={mediaUrl+'membership/'+this.state.old_wallletplan_img} alt="" />
			;

  	
return (
	<div className="wrapper"> 

		<Header />
		<MenuSidebar currentpage="walletplans" currentTab="common" />  
		<div className="content">	
			<div className="content-wrapper">
				<div class="content-wrapper-before"></div>
				<div className="form-wrapper leaa-admin-head card">
					<div className="success_message"></div>
					<div>
						<a class="primary-btn" href="/walletplans">Back</a>
					</div>
					<div className="title">
						<h4>Edit Wallet Plan</h4>
					</div>
					<form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} encType="multipart/form-data">
						<div className="form-row">
							 <div className="form-left">
                    <div className="form-group">
                      <label>
                        Plan Name
                        <span class="required" style={{ color: "red" }}>
                          *{" "}
                        </span>
                      </label>
                       <input
                        type="text"
                        name="title"
                        onChange={this.handleInputChange}
                        className="form-control"
                        value={this.state.title}
                      />
                     
                      <div className="errortitle"></div>
                    </div>
                    <div className="form-group">
                      <label>
                        {" "}
                        Wallet Amount ($)
                        <span class="required" style={{ color: "red" }}>
                          *{" "}
                        </span>{" "}
                      </label>
                      <input
                        type="text"
                        name="walletAmt"
                        onChange={this.handleInputChange}
                        className="form-control"
                        value={this.state.walletAmt}
                      />
                      <div className="errorwalletAmt"></div>
                    </div>
                    <div className="form-group">
                      <label>
                        {" "}
                        Earned Points
                        <span class="required" style={{ color: "red" }}>
                          *{" "}
                        </span>{" "}
                      </label>
                      <input
                        type="text"
                        name="earnPoints"
                        onChange={this.handleInputChange}
                        className="form-control"
                        value={this.state.earnPoints}
                      />
                      <div className="errorearnPoints"></div>
                    </div>
                    <div className="form-group">
                      <label>
                        {" "}
                        Extra Bonus Points
                        {/* <span class="required" style={{ color: "red" }}>
                          *{" "}
                        </span>{" "} */}
                      </label>
                      <input
                        type="text"
                        name="extraBonusPoints"
                        onChange={this.handleInputChange}
                        className="form-control"
                        value={this.state.extraBonusPoints}
                      />
                      <div className="errorextraBonusPoints"></div>
                    </div>
                 
                   
                    <div className="form-group">
                      <label>Image (jpeg,jpg,png,svg)</label>
                      <div className="choose-file">
                        {this.state.isHidden && (
                          <div className="image_success"></div>
                        )}
                        <span className="profile_btn">
                          <input
                            type="file"
                            name="file"
                            onChange={this.onChangeHandler}
                          />
                        </span>
                      </div>
                      {preview}
                      <div className="errorimage"></div>
                    </div>
                   
                  </div>

                  <div className="form-right">

                     <div className="form-group">
                      <label>Plan Benefits</label>
                      <CKEditor
                        editor={ClassicEditor}
                        data={this.state.planBenefits || ""}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                        }}
                        name="planBenefits"
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          this.onEditorChange("planBenefits", data);
                        }}
                      />
                      <div className="errorplanBenefits"></div>
                    </div>
                    
                    <div className="form-group">
                      <label>Description</label>
                           <CKEditor
                        editor={ClassicEditor}
                        data={this.state.description || ""}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                        }}
                        name="description"
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          this.onEditorChange("description", data);
                        }}
                      />
                      {/* <textarea style={{minHeight: "180px"}} type="text" name='description' onChange={this.handleInputChange} className='form-control' value={this.state.description} /> */}
                      {/* <MyEditor
                        onEditorChange={this.onEditorChange.bind(
                          this,
                          "description",
                        )}
                      ></MyEditor> */}
                      {/* <div id="editor" onChange={this.onEditorChange}></div> */}
                      <div className="errordescription"></div>
                    </div>
                    <div className="form-group">
                      <label>
                        Status
                        <span class="required" style={{ color: "red" }}>
                          *
                        </span>
                      </label>
                      <Select
                        name="status"
                        value={
                          selectedOption
                            ? selectedOption
                            : { value: "active", label: "Active" }
                        }
                        options={lang.common.status_option}
                        isSearchable={false}
                        onChange={this.handleChange.bind(this, "status")}
                      />
                    </div>
                  </div>	
						</div>		

						<div className="btn-group export">	
							<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true? <span>updating</span>:<span>Submit</span>}
							</button>
						</div>
					</form>
				</div>				
			</div>	
		</div>
	</div>
	);
}
}


// const mapStateTopProps = (state) => {
//   return {
//     membershipdetails: state.membershipdetails,
//     membershipedit: state.membershipedit
//   }
// }

// const mapDispatchToProps = (dispatch) => {
//   return {
//     getCategoryDetailList: (memId) =>{
//        dispatch({ type: GET_CATEGORYDETAILLIST,memId });
//     },
//     getEditCategory: (formPayload) =>{
//        dispatch({ type: GET_EDITCATEGORY, formPayload});
//     }
//   }
// }
export default (withRouter(WalletPlanEdit));